<ng-container *ngIf="outstandingCalls$ | async as visible">
<div class="cevi-loading-slider" *ngIf="visible">
    <div class="cevi-loading-line"></div>
    <div class="cevi-loading-subline cevi-loading-inc"></div>
    <div class="cevi-loading-subline cevi-loading-dec"></div>
  </div>
  <div class="cevi-loading-overlay" *ngIf="visible"></div>
</ng-container>  